import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { branchIfTruthy } from 'ad-hok-utils'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'

import backIcon from 'assets/caret-left.svg'
import { Button } from 'components/Button'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { MODAL_Z_INDEX } from 'utils/zIndex'
import { ConstrainWidth } from '../../utils/layout'
import { addShowRegisterContext } from '../../utils/register'
import { LoginSection } from './LoginSection'
import { RegisterLasso } from './RegisterLasso'

const useStyles = createUseStyles({
  container: {
    backgroundColor: '#000',
    display: 'flex',
    flexDirection: 'column',
    zIndex: MODAL_Z_INDEX,
    position: 'relative',
    width: '100%',
  },
  navbar: {
    paddingTop: 25,
    paddingLeft: 13,
    height: 32,
  },
  backIcon: {
    height: 20,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '26px 23px',
    paddingTop: 170,
    justifyContent: 'space-between',
    flex: 1,
  },
})

export const addRegisterPage = flowMax(
  addShowRegisterContext,
  branchIfTruthy('showRegister', {
    returns: () => <Register />,
  })
)

export const Register: FC = flowMax(
  addDisplayName('Register'),
  addTranslationHelpers,
  addShowRegisterContext,
  addHandlers({
    onBack:
      ({ setShowRegister }) =>
      () => {
        setShowRegister(false)
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ onBack, classes }) => (
    <ConstrainWidth fillHeight className={classes.container}>
      <div className={classes.navbar}>
        <Button onClick={onBack}>
          <img src={backIcon} alt="" className={classes.backIcon} />
        </Button>
      </div>
      <div className={classes.content}>
        <RegisterLasso />
        <LoginSection />
      </div>
    </ConstrainWidth>
  )
)
